import { Component } from '@theme/component';
import { morph } from '@theme/morph';

/**
 * A custom element that manages a product links dropdown.
 *
 * @template {import('@theme/component').Refs} [Refs = {}]
 *
 * @extends Component<Refs>
 */
export default class ProductLinks extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('change', this.handleChange.bind(this));
  }

  /**
   * Handles the dropdown change event.
   * @param {Event} event - The change event.
   */
  handleChange(event) {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const selectedValue = event.target.value;
    const currentUrl = this.dataset.currentUrl || window.location.pathname;

    // Don't navigate if the same URL is selected
    if (selectedValue === currentUrl) return;

    // Navigate to the selected URL
    if (selectedValue.startsWith('http')) {
      // External URL - redirect
      window.location.href = selectedValue;
    } else {
      // Internal URL - morph the page
      this.navigateToPage(selectedValue);
    }
  }

  /**
   * Navigates to a page using morphing.
   * @param {string} url - The URL to navigate to.
   */
  async navigateToPage(url) {
    try {
      // Navigate exactly like a link click so existing page-transition logic runs
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      // Clean up the temporary anchor
      setTimeout(() => anchor.remove(), 0);
    } catch (_) {
      // Fallback
      window.location.href = url;
    }
  }
}

// Register the custom element
if (!customElements.get('product-links')) {
  customElements.define('product-links', ProductLinks);
}

